export default {
  state: {
    data: {},
  },
  mutations: {
    'favourite/setState'(store, payload) {
      try {
        store.data = { ...payload };
      } catch (err) {
        console.error(err);
      }
    },

    'favourite/updateSKU'(store, { payload, product }) {
      store.data = {
        ...store.data,
        likes: store.data.likes.map((el) => {
          if (el !== payload.result) {
            return el;
          }

          return product;
        }),
      };

      /** change sku in groups * */

      if (payload.groupId) {
        const groupIndex = store.data.groups.findIndex((el) => el.id === payload.groupId);
        if (groupIndex !== -1) {
          const groups = [...store.data.groups];

          groups[groupIndex] = {
            ...groups[groupIndex],
            items: groups[groupIndex].items.map((el) => {
              if (el !== payload.result) {
                return el;
              }

              return product;
            }),
          };

          store.data = {
            ...store.data,
            groups,
          };
        }
      }
    },
  },
  actions: {
    /**
     * add product to present group
     * @param data
     * @param commit
     * @param payload
     * @returns {Promise<void>}
     */
    // async ['favourite/add']({ state: { data }, commit }, payload) {
    //     try{
    //         const { path, ['params-example-data']: { action } } = data.routes.addLike;
    //         const params = {
    //             action,
    //             id: payload,
    //         }
    //
    //         const response = await axios.post(path, params);
    //
    //         if (response.status === 200) {
    //             commit('favourite/setState', response.data);
    //             commit('favourite/changeOpenFavourite', true);
    //         }
    //     } catch( err ) {
    //         console.error(err);
    //     }
    // },
    /**
     * add product to new group
     * @param data
     * @param commit
     * @param payload
     * @returns {Promise<void>}
     */
    async 'favourite/createNewGroup'({ state: { data }, commit }, payload) {
      try {
        const {
          path,
          'params-example-data': { action },
        } = data.routes.addLikeGroup;

        const requestData = payload;

        if (payload instanceof FormData) {
          requestData.set('action', action);
        } else {
          payload.action = action;
        }

        const response = await axios.post(path, requestData);

        if (response.status === 200) {
          commit('favourite/setState', response.data);
        }
      } catch (err) {
        console.error(err);
      }
    },

    async 'favourite/addLikeToBaseGroup'({ state: { data }, commit }, payload) {
      try {
        const {
          path,
          'params-example-data': { action },
        } = data.routes.addLikeToBaseGroup;

        const requestData = payload;

        if (payload instanceof FormData) {
          requestData.set('action', action);
        } else {
          payload.action = action;
        }

        const response = await axios.post(path, requestData);

        if (response.status === 200) {
          commit('favourite/setState', response.data);
        }
      } catch (err) {
        console.error(err);
      }
    },

    /**
     * remove item from favourite
     * if groupId param is missing, remove item from all groups
     *
     * @param data
     * @param commit
     * @param payload
     * @returns {Promise<void>}
     */

    async 'favourite/remove'({ state: { data }, commit, getters }, payload) {
      try {
        const {
          path,
          'params-example-data': { action },
        } = data.routes.deleteLike;

        const response = await axios.post(path, {
          action,
          ...payload,
        });
        if (response.status === 200) {
          commit('favourite/setState', response.data);
          if (!data?.likes?.length) {
            commit('favourite/changeOpenFavourite', false);
          }
        }
      } catch (err) {
        console.error(err);
      }
    },

    /**
     * remove items group
     * @param data
     * @param commit
     * @param getters
     * @param payload
     * @returns {Promise<void>}
     */
    async 'favourite/removeGroup'({ state: { data }, commit, getters }, payload) {
      try {
        const {
          path,
          'params-example-data': { action },
        } = data.routes.deleteLikeGroup;

        const response = await axios.post(path, {
          action,
          ...payload,
        });

        if (response.status === 200) {
          commit('favourite/setState', response.data);
        }
      } catch (err) {
        console.error(err);
      }
    },

    /**
     *  change group name
     * @param data
     * @param commit
     * @param getters
     * @param payload
     * @returns {Promise<void>}
     */

    async 'favourite/changeGroupName'({ state: { data }, commit }, payload) {
      const {
        path,
        'params-example-data': { action },
      } = data.routes.renameLikeGroup;

      payload.set('action', action);
      // payload.set('groupId', +payload.get('groupId'));

      const response = await axios.post(path, payload);
      // console.log(response.data);
      if (response.status === 200) {
        commit('favourite/setState', response.data);
      }
    },

    /**
     * change group status for default by groupId
     * @param data
     * @param commit
     * @param payload
     * @returns {Promise<void>}
     */

    // async ['favourite/changeLikeGroup'] ({ state: { data }, commit, getters}, payload) {
    //     const { path, ['params-example-data']: { action } } = data.routes.changeLikeGroup;
    //
    //     const params = {
    //         ...payload,
    //         ...getters.getRequestLang,
    //         action,
    //         changeBase: 'Y',
    //     };
    //
    //     const response = await axios.post(path, params);
    //
    //     if (response.status === 200) {
    //         commit('favourite/setState', response.data);
    //     }
    // },

    async 'favourite/moveProductsToGroup'({ state: { data }, commit, getters }, payload) {
      const {
        path,
        'params-example-data': { action },
      } = data.routes.moveLikesGroup;

      payload.set('action', action);

      const response = await axios.post(path, payload);

      if (response.status === 200) {
        commit('favourite/setState', response.data);
      }
    },

    async 'favourite/changeSKU'({ state: { data }, commit, getters }, payload) {
      try {
        commit('global/loaderStart');
        const { result, size } = payload;

        // remove old product
        await axios.post(data.routes.deleteLike.path, {
          action: data.routes.deleteLike['params-example-data'].action,
          id: (result.offer && result.offer.id) || result.id,
        });

        // add new product
        await axios.post(data.routes.addLikeGroup.path, {
          action: data.routes.addLikeGroup['params-example-data'].action,
          id: size.id,
        });

        // get new product
        const { detailPage } = payload.size;
        const { status, data: responseData } = await axios.get(detailPage, {
          params: {
            ...getters.getRequestLang,
            api: 'Y',
          },
        });

        if (status !== 200) {
          throw `bad response status ${status}`;
        }

        if (responseData?.product) {
          commit('favourite/updateSKU', { payload, product: responseData?.product });
        }

        commit('global/loaderStop');
      } catch (err) {
        console.error(err);
      }
    },
    async 'favourite/getLikesCountByProductId'({ state: { data } }, payload) {
      try {
        const {
          path,
          'params-example-data': { action },
        } = data?.routes?.getLikesCountByProductId;

        payload.action = action;
        const requestData = payload;

        const response = await axios.post(path, requestData);
        return response?.data?.count ?? 0;
      } catch (err) {
        console.error(err);
      }
    },
  },
  getters: {
    'favourite/inFavourite': (state) => (payload) => {
      try {
        return !!Object.values(state?.data?.likes)?.find((el) => {
          const id = el.offer?.id || el.id;

          return id == payload;
        });
      } catch (err) {
        console.log(err);
      }
    },
  },
};
